<template>
  <div>
    <div>
      <p></p>
      <strong><T>Типы доставки</T></strong>
      <div v-for="key in deliveryKeys" :key="key">
        <CheckBox
          class="ml-4"
          :label="getLabel(key)"
          :hint="getHint(key)"
          :original_value="config[key]"
          v-model="local_config[key]"
        />
      </div>
    </div>

    <div class="mt-4">
      <strong><T>Типы оплат</T></strong>
      <div v-for="key in paymentKeys" :key="key">
        <CheckBox
          class="ml-4"
          :label="getLabel(key)"
          :hint="getHint(key)"
          :original_value="config[key]"
          v-model="local_config[key]"
          :disabled="isDisabled(key)"
        />
      </div>
    </div>

    <div class="mt-4">
      <strong><T>Настройка комментария в магазине</T></strong>

      <v-row
        class="mt-2"
        v-for="(labelKey, index) in labelCommentShop"
        :key="labelKey"
         align="center"
      >
        <v-col cols="12" md="6">
          <TextField
            :label="getLabel(labelKey)"
            :hint="getHint(labelKey)"
            :original_value="config[labelKey]"
            v-model="local_config[labelKey]"
          />
        </v-col>

        <v-col
          cols="12"
          md="6"
          class="d-flex align-center checkbox-column"
        >
          <CheckBox
            :label="getLabel(commentKeys[index])"
            :hint="getHint(commentKeys[index])"
            :original_value="config[commentKeys[index]]"
            v-model="local_config[commentKeys[index]]"
          />
        </v-col>
      </v-row>
    </div>

    <div class="mt-4">
      <strong><T>Подтверждения</T></strong>
      <div>
        <CheckBox
          class="ml-4"
          :label="$t('Необходимо подтверждать неоплаченные заказы')" 
          :hint="$t('Необходимо подтверждать неоплаченные заказы из магазина')" 
          :original_value="config.confirm_order"
          v-model="local_config.confirm_order"
        />
      </div>
    </div>
  </div>
</template>

<script>
import settings_group_mixin from '../settings_group_mixin'
import CheckBox from '../../common/CheckBox.vue'
import TextField from '../../common/TextField.vue'

export default {
  mixins: [settings_group_mixin],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      local_loading: false,
      locales: [],
      local_config: {},
      deliveryKeys: ['allow_delivery', 'allow_pickup', 'allow_inside'],
      paymentKeys: ['allow_pay_card_offline', 'allow_pay_card_online', 'allow_pay_cash'],
      commentKeys: ['comment_for_delivery', 'comment_for_pickup', 'comment_for_inside'],
      labelCommentShop: ['label_comment_shop_delivery', 'label_comment_shop_pickup', 'label_comment_shop_inside']
    }
  },
  watch: {
    local_config: {
      handler(newVal) {
        this.$emit('configChanged', newVal)
      },
      deep: true
    },

  '$store.getters.local_refs'(val) {
    if (!val) {
      this.local_config.allow_pay_card_online = false
    }
  }
  },
  computed: {
    checkboxLabels() {
      return {
        allow_delivery: this.$t('Разрешить доставку'),
        allow_inside: this.$t('Разрешить заказы в заведении'),
        comment_for_delivery: this.$t('Обязательный для доставки'),
        comment_for_pickup: this.$t('Обязательный для самовывоза'),
        comment_for_inside: this.$t('Обязательный для зала'),
        allow_pay_card_offline: this.$t('Разрешить оплату картой при получении'),
        allow_pay_card_online: this.$t('Разрешить оплату картой онлайн'),
        allow_pay_cash: this.$t('Разрешить оплату наличными'),
        allow_pickup: this.$t('Разрешить самовывоз'),
        label_comment_shop_delivery: this.$t('Комментарий для доставки'),
        label_comment_shop_pickup: this.$t('Комментарий для самовывоза'),
        label_comment_shop_inside: this.$t('Комментарий заказа в зале'),
      }
    },
    checkboxHints() {
      return {
        allow_delivery: this.$t('Заказ будет доставлен курьером'),
        allow_inside: this.$t('Заказы можно забирать самостоятельно и сесть за стол'),
        allow_pay_card_offline: this.$t('Заказы можно оплачивать картой при получении заказа от курьера'),
        allow_pay_card_online: this.$t('Заказы можно оплачивать картой онлайн при оформлении заказа'),
        allow_pay_cash: this.$t('Оплата производится наличными курьеру'),
        allow_pickup: this.$t('Заказы можно забирать самостоятельно из ресторана'),
        comment_for_delivery: this.$t('Обязательный комментарий для доставки в магазине'),
        comment_for_pickup: this.$t('Обязательный комментарий для самовывоза заказа'),
        comment_for_inside: this.$t('Обязательный комментарий для заказов в зале'),
        label_comment_shop_delivery: this.$t('Комментарий для доставки'),
        label_comment_shop_pickup: this.$t('Комментарий для самовывоза'),
        label_comment_shop_inside: this.$t('Комментарий заказа в зале'),
      }
    },
    any_loading() {
      return this.local_loading
    }
  },
  created() {
    this.local_config = { ...this.config }

    if (!this.$store.getters.local_refs) {
      this.local_config.allow_pay_card_online = false
  }
  },
  methods: {
    getLabel(key) {
      return this.checkboxLabels[key] || key
    },
    getHint(key) {
      return this.checkboxHints[key] || ''
    },
    isDisabled(key) {
      if (key === 'allow_pay_card_online') {
        return !this.$store.getters.local_refs.pay_settings.pay_enable
      }
      return false
    },
    async loadLocales() {
      this.local_loading = true
      try {
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } finally {
        this.local_loading = false
      }
    },
    submit() {
      return this.local_config
    }
  },
  mounted() {
    this.loadLocales()
  },
  components: {
    CheckBox,
    TextField
  }
}
</script>
<style>
.checkbox-column * {
    margin-top: 0 !important;
    margin-bottom: 4px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>